import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="flex flex-col justify-center items-center px-4 md:px-6 py-12 md:py-16 bg-cream relative overflow-hidden" data-id="element-151">
      <div className="max-w-4xl mx-auto text-center z-10" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-153">
          <p className="text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-154">
            Para la mujer que ya no acepta migajas
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-155">
            El Salto de
            <br data-id="element-156" />
            <span className="text-gold italic text-2xl md:text-5xl lg:text-6xl" data-id="element-157">
              Novia a Esposa
            </span>
          </h1>
          <p className="text-base md:text-lg text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-158">
            Descubre si tu relación tiene futuro real, aplica los scripts
            exactos para la conversación de claridad y conviértete en la mujer
            de alto valor que él elige para siempre.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-8 relative" data-id="element-159">
          <div className="absolute inset-0 bg-gold/10 transform rotate-2 rounded-xl" data-id="element-160"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9cgic44UWCz2Tsv7VB89BV/SALTO_A_ESPOSA_NEW_1.1.png" alt="El Salto de Novia a Esposa eBook" className="w-full max-w-xs md:max-w-lg mx-auto rounded-xl shadow-2xl relative z-10 border-4 border-white" data-id="element-161" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-162">
          <Button className="w-full md:w-auto text-base px-8 py-4 flex items-center justify-center gap-3" data-id="element-163">
            <span data-id="element-164">Quiero transformarme en una mujer de alto valor ahora</span>
            <ArrowRightIcon className="w-5 h-5" data-id="element-165" />
          </Button>
          <p className="mt-4 text-sm text-gray-600 font-medium tracking-wide" data-id="element-166">
            ✓ Acceso inmediato &nbsp;|&nbsp; ✓ Formato digital
          </p>
        </motion.div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-blush rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 -translate-y-1/2" data-id="element-167"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gold rounded-full mix-blend-multiply filter blur-3xl opacity-20 translate-x-1/3 translate-y-1/3" data-id="element-168"></div>
    </section>;
}